export default [
    'Courting',
    'Loan In Process',
    'Closed',
    'Terminated',
    'Follow Up'
];
